import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import ClassSchedule from './ClassSchedule';
import { duJingClassSchedule } from '../../util/constants';

const DuJingClassSchedule = props => {
  const styles = {
    title: {
      marginTop: 20,
      textAlign: 'center',
      marginBottom: 10
    },
    duJingClassSchedule: {
      marginBottom: 20,
      textAlign: 'center'
    }
  }

  return (
    <Grid
      constainer
      direction='row'
      justifyContent='center'
    >
      <Grid
        item
        xs={12}
      >
        <Typography
          variant="h5"
          component="div"
          style={styles.title}
        >
          親子兒童讀經班
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        style={styles.duJingClassSchedule}
      >
        <Grid
          container
          direction='row'
          justifyContent='center'
        >
          {
            duJingClassSchedule.map((theClass, i) => {
              return (
                <React.Fragment>
                  <Grid item xs={1} sm={2}></Grid>
                  <Grid
                    item
                    xs={10}
                    sm={8}
                    style={styles.duJingClassSchedule}
                  >
                    <ClassSchedule theClass={theClass} />
                  </Grid>
                  <Grid item xs={1} sm={2}></Grid>
                </React.Fragment>
              )
            })
          }
        </Grid>
      </Grid>
      
    </Grid>
  )
}

export default DuJingClassSchedule;